enum BadgeRoutes {
  List = '/badges',
  Edit = '/badges/edit/:id',
  Add = '/badges/add',
}

export default BadgeRoutes
